// decimales: 0 por defecto. Las pantallas fiscales (CFDI) necesitan 2, ahí el
// centavo importa porque el dato tiene que cuadrar con la factura.
export const formatCurrency = (value, decimales = 0) => {
  // Validar y convertir valor a número
  if (value === null || value === undefined) return '$0 MXN';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return '$0 MXN';

  const formatted = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(numValue);
  return formatted;
};

// Versión corta para ejes de gráficas: $12.5 k, $1.3 M (es-MX, notación compacta)
export const formatCurrencyCompacto = (value) => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (numValue === null || numValue === undefined || isNaN(numValue)) return '$0';
  return new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', notation: 'compact', maximumFractionDigits: 1,
  }).format(numValue);
};

// Para texto libre que el backend arma con el monto ya incrustado en la
// oracion ("Recorta $1,240 en Restaurantes..."), donde no hay un valor suelto
// que envolver en <Monto>. Reemplaza el patron "$1,234.56" por la mascara,
// donde aparezca dentro del texto.
// Escapa texto para meterlo en HTML armado a mano (el reporte imprimible lo
// escribe con document.write). En JSX no hace falta: React ya escapa.
export const escaparHTML = (valor) =>
  String(valor ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export const enmascararMontosEnTexto = (texto, mascara) =>
  // \d{1,3}(?:,\d{3})* en vez de [\d,]+: la version anterior era tan codiciosa
  // que se comia la coma que separa clausulas de la oracion ("gastaras $X, $Y
  // mas que...") junto con el numero, dejando dos mascaras pegadas sin la
  // coma. Este patron solo acepta comas de miles, exactamente 3 digitos.
  texto ? texto.replace(/\$\s?-?\d{1,3}(?:,\d{3})*(?:\.\d+)?/g, mascara) : texto;
